import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/invoices/new/loading';

export const Route = createFileRoute('/_private/invoices/new')({
  pendingComponent: Loading,
});
